import type { IBug, IErrorDetail, IErrorResponse } from "Common/Interfaces";
import { adminBaseAPI } from "src/Store/AdminBaseAPI";
import { transformErrorResponse } from "src/Store/Functions";

const controller = "bugtracker";
export const bugTrackerApi = adminBaseAPI.injectEndpoints({
  endpoints: (build) => ({
    createBug: build.mutation<IBug, FormData>({
      query: (formData) => {
        return {
          url: `/${controller}`,
          method: "POST",
          headers: {
            isSingleFileUpload: "true",
          },
          body: formData,
        };
      },
      transformErrorResponse: (response: IErrorResponse): IErrorDetail => {
        return transformErrorResponse(response);
      },
    }),
  }),

  overrideExisting: false,
});

export const { useCreateBugMutation } = bugTrackerApi;
